import React from 'react';
export const Feature70DataSource = {
  wrapper: {
    className: 'home-page-wrapper feature7-wrapper l5kp8hfix2n-editor_css',
  },
  page: { className: 'home-page feature7 l5kpczhzjkc-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper l5kp8nxln7-editor_css',
    children: [
      {
        name: 'title',
        className: 'feature7-title-h1',
        children: (
          <span>
            <p>关于融云</p>
          </span>
        ),
      },
      {
        name: 'content',
        className: 'feature7-title-content l5kp9fg9w29-editor_css',
        children: (
          <span>
            <p>About Us</p>
          </span>
        ),
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper l5kp82t8nb-editor_css',
    gutter: 24,
    children: [
      {
        md: 6,
        xs: 24,
        name: 'block0',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:
                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '身份证',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
            },
          ],
        },
      },
    ],
  },
};
export const Feature01DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5m8fcpsxnu-editor_css',
  },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>服务架构</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 24,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon l5m8emul32f-editor_css',
              children:
                'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/85d13b7f-ecb0-405e-b0b0-4e136aed745f.png',
            },
          ],
        },
      },
    ],
  },
};
